import { action } from '@ember/object';
import Component from '@glimmer/component';
import type UserModel from 'bcl/models/user';
import Wide from 'bcl/components/input/wide';
import { on } from '@ember/modifier';
import SelectUserRoles from 'bcl/components/input/select-user-roles';

export interface UserEditSignature {
  // The arguments accepted by the component
  Args: {
    model: UserModel | undefined;
    closeModal: () => void;
  };
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: null;
}
export default class UserEditComponent extends Component<UserEditSignature> {
  <template>
    <form class="mx-4 sm:mx-0">
      <div class="space-y-12">
        <div class="border-b border-gray-900/10 pb-12">

          <div class="grid grid-cols-1 gap-x-6 sm:grid-cols-6">

            <Wide
              @label="Name"
              @name="name"
              @type="text"
              @value={{@model.name}}
            />
            <Wide
              @label="Email"
              @name="email"
              @type="text"
              @value={{@model.email}}
            />
            <SelectUserRoles
              @label="Rolle"
              @name="role"
              @value={{@model.role}}
              @onChange={{this.updateRole}}
            />
            <span
              class="block sm:col-span-6 text-sm font-medium leading-6 text-gray-900 mt-4"
            >
              Neues Passwort setzen (leer lassen um das Passwort nicht zu
              ändern):
            </span>
            <Wide
              @label="Neues Passwort"
              @name="password"
              @type="password"
              @value={{@model.password}}
            />

          </div>
        </div>

      </div>

      <div class="mt-6 flex items-center justify-end gap-x-6">
        <button
          {{on "click" this.cancel}}
          type="button"
          class="text-sm font-semibold leading-6 text-gray-900"
        >abbrechen</button>
        <button
          {{on "click" this.save}}
          type="button"
          class="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >Speichern</button>
      </div>
    </form>
  </template>

  @action
  cancel() {
    this.args.model.rollbackAttributes();
    this.args.closeModal();
  }
  @action
  async save() {
    const user = this.args.model;
    if (user.hasDirtyAttributes) {
      await user.save();
    }
    this.args.closeModal();
  }
  @action updateRole(value: string) {
    this.args.model.role = value;
  }
}
